module.exports = __webpack_public_path__ + "img/4.a209569c.png";